import { useAtom } from "jotai";

import { Button } from "@/components/ui/Button";
import { sizes } from "@/components/ui/Button/utils";
import {
  DropdownSelect,
  DropdownSelectItem,
} from "@/components/ui/Dropdown/DropdownSelect";

import cn from "@/utils/cn";

import {
  LANGUAGE_NAMES,
  SupportedLocale,
} from "../../../../scripts/i18n/types";

import { useIsMobile } from "@/hooks/useIsMobile";
import { localeAtom } from "@/i18n/atoms";

const languages: DropdownSelectItem[] = Object.entries(LANGUAGE_NAMES).map(
  ([locale, name]) => ({
    key: locale,
    label: name,
    value: locale,
  }),
);

export const LanguageSwitcher = ({
  variant = "default",
  size = "sm",
}: {
  variant?: "orgSwitcher" | "default";
  size?: keyof typeof sizes;
}) => {
  const [locale, setLocale] = useAtom(localeAtom);
  const selectedLanguage = languages.find((item) => item.key === locale);
  const isMobile = useIsMobile();

  const onChange = (item: DropdownSelectItem) => {
    setLocale(item.key as SupportedLocale);
    // TODO(SWE-1057): Remove page reload once workaround is found for Google
    // maps SDK requiring refresh.
    window.location.reload();
  };

  return (
    <DropdownSelect
      autoHeight
      selected={selectedLanguage}
      items={languages}
      onChange={onChange}
      contentClassname="w-[120px]"
      contentAlign="end"
      chevronClassName={cn({
        "max-md:text-current md:text-white": variant === "orgSwitcher",
      })}
    >
      <Button
        variant={
          variant === "orgSwitcher" && !isMobile ? "primary" : "transparent"
        }
        size={size}
      >
        {selectedLanguage?.label}
      </Button>
    </DropdownSelect>
  );
};
